<template>
  <div class="visual-positioning-canvas" :class="{ 'full-screen-canvas': props.isFullScreen }">
    <div class="visual-positioning-canvas-sizer"></div>
    <div class="visual-positioning-canvas-visuals">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ isFullScreen?: boolean }>();
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.session.session-inline .visual {
  align-items: center;

  .visual-positioning-canvas:not(.full-screen-canvas) {
    max-width: 75vh;
  }
}

.visual-positioning-canvas {
  position: relative;
  width: 100%;
  max-width: 100vh;

  &.full-screen-canvas {
    position: fixed;
    max-width: 100vw;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

.visual-positioning-canvas-sizer {
  padding-top: 100%;
}

.visual-positioning-canvas-visuals {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
